import React from 'react'
import { Loading, Text } from 'snacks-design-system'

interface SuspenseLoadingProps {
  text?: string
}

export const SuspenseLoading = ({
  text = 'Loading...',
}: SuspenseLoadingProps) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: '24px',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '48px',
          height: '48px',
        }}
      >
        <Loading size="xl" isActive={true} />
      </div>
      <Text
        size="var(--xds-font-size-20)"
        fontWeight="var(--xds-font-weight-bold)"
      >
        {text}
      </Text>
    </div>
  )
}
